import JumboCardQuick from '@jumbo/components/JumboCardQuick';
import { Box, Button, Card, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Switch, FormControlLabel, FormLabel } from "@mui/material";
import { postSaveObjectApi, putUpdateObjectApi } from "api/general";
import { UNITS } from "app/utils/constants/customConstant";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

function AddUpdateUnitCard({ afterUpdateFunc, selectedUnit, onClose, addAfterTable }) {


    const empty_unitObj = { inst: '', name: '', uploadFileStatus: 0 }
    const [unitObj, setUnitObj] = useState(selectedUnit ? selectedUnit : empty_unitObj)
    const allAuthorizedInsts = useSelector(state => state.auth.allAuthorizedInsts);
    useEffect(() => {
        setUnitObj(selectedUnit ? selectedUnit : empty_unitObj)
    }, [selectedUnit])

    const handleChange = name => (e) => {
        setUnitObj({
            ...unitObj,
            [name]: e.target.value
        })
    }

    const handleSwitchChange = (name) => (event) => {
        setUnitObj({
            ...unitObj,
            [name]: event.target.checked ? 1 : 0
        })
    }

    const handleAddUpdateUnitInfo = () => {
        onClose();

        selectedUnit ?

            Swal.fire({
                title: 'Kurul/Kol/Komisyon Güncelleme İşlemi',
                text: "Güncellemek istediğinizden emin misiniz?",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Evet Güncelle',
                cancelButtonText: "Vazgeç"
            }).then(async (result) => {
                if (result.isConfirmed) {

                    delete unitObj['location']
                    const result = await putUpdateObjectApi(UNITS, unitObj);

                    if (result.status) {
                        Swal.fire({
                            position: 'center',
                            icon: 'success',
                            title: 'Güncelleme başarılı.',
                            showConfirmButton: false,
                            timer: 1500
                        });

                        afterUpdateFunc && afterUpdateFunc({ ...unitObj })
                    }
                }
            })

            :

            Swal.fire({
                title: 'Kurul/Kol/Komisyon Ekleme İşlemi',
                text: "Eklemek istediğinizden emin misiniz?",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Evet Ekle',
                cancelButtonText: "Vazgeç"
            }).then(async (result) => {
                if (result.isConfirmed) {

                    const result = await postSaveObjectApi(UNITS, unitObj);

                    if (result.status) {
                        Swal.fire({
                            position: 'center',
                            icon: 'success',
                            title: 'Ekleme başarılı.',
                            showConfirmButton: false,
                            timer: 1500
                        });

                        addAfterTable({ id: result.data.insertId, ...unitObj })


                    }
                }
            })
    };


    return (
        <>

            <JumboCardQuick>

                <Grid container marginY={1} spacing={1} rowSpacing={1}>

                    <Grid item xs={3} >
                        <FormControl fullWidth
                        >
                            <InputLabel id="inst">Kurum</InputLabel>
                            <Select
                                labelId='inst'
                                label="Kurum"
                                value={unitObj['inst']}
                                small="large"
                                fullWidth
                                onChange={handleChange("inst")}
                                required
                            >
                                {
                                    allAuthorizedInsts.map(item => (
                                        <MenuItem key={item.id} value={item}>
                                            {item}
                                        </MenuItem>
                                    ))
                                }
                            </Select>

                        </FormControl>
                    </Grid>



                    <Grid item xs={6} md={6}>
                        <TextField
                            variant="outlined"
                            label="İsim"
                            multiline fullWidth

                            value={unitObj['name']}
                            onChange={handleChange("name")}
                        />
                    </Grid>

                    <Grid item xs={3}>
                        <FormControl fullWidth>
                            <FormLabel component="legend" >Rapor Yükleme Zorunluluğu</FormLabel>
                            <Switch
                                checked={unitObj['uploadFileStatus'] === 1}
                                onChange={handleSwitchChange("uploadFileStatus")}
                                color="primary"
                            />
                        </FormControl>
                    </Grid>

                </Grid>
            </JumboCardQuick >

            <br />
            <Card>
                <Box sx={{ margin: '8px' }}>
                    <Grid container justifyContent="flex-end" spacing={1}>
                        <Grid item>
                            <Button variant="contained" color="success" onClick={() => handleAddUpdateUnitInfo()}>
                                {selectedUnit ? "Güncelle" : "Kaydet"}
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button variant="contained" color="error" onClick={() => onClose()}>
                                Kapat
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Card>


        </>
    )
}

export default AddUpdateUnitCard